import React from "react";
import { Filter, Loader2, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { DosyaMuvekkilSelect, RayicAccordion } from "./RayicShared";

export default function RayicArastirSidebar({
    form,
    setForm,
    gelismis,
    setGelismis,
    showGelismis,
    setShowGelismis,
    arastirBusy,
    onArastir,
}) {
    return (
        <div className="space-y-2 h-full overflow-y-auto">
            <RayicAccordion title="Araç & Dosya" defaultOpen>
                <div className="space-y-2">
                    <Input
                        value={form.marka}
                        onChange={(e) => setForm((f) => ({ ...f, marka: e.target.value }))}
                        className="h-8 bg-black/20 border-white/10 text-xs"
                        placeholder="Marka"
                    />
                    <Input
                        value={form.model}
                        onChange={(e) => setForm((f) => ({ ...f, model: e.target.value }))}
                        className="h-8 bg-black/20 border-white/10 text-xs"
                        placeholder="Model"
                    />
                    <div className="grid grid-cols-2 gap-1.5">
                        <Input
                            type="number"
                            value={form.model_yili}
                            onChange={(e) => setForm((f) => ({ ...f, model_yili: Number(e.target.value) }))}
                            className="h-8 bg-black/20 border-white/10 text-xs"
                            placeholder="Yıl"
                        />
                        <Input
                            type="number"
                            value={form.km}
                            onChange={(e) => setForm((f) => ({ ...f, km: Number(e.target.value) }))}
                            className="h-8 bg-black/20 border-white/10 text-xs"
                            placeholder="KM"
                        />
                    </div>
                    <DosyaMuvekkilSelect
                        value={form.dosya_id}
                        onChange={(id) => setForm((f) => ({ ...f, dosya_id: id }))}
                        onDosyaMeta={(row) =>
                            setForm((f) => ({
                                ...f,
                                dosya_id: String(row.id),
                                marka: row.marka || f.marka,
                                model: row.model || f.model,
                                model_yili: row.model_yili || f.model_yili,
                            }))
                        }
                    />
                    <Button
                        className="w-full h-8 text-xs bg-[#D4AF37] text-black hover:bg-[#c4a030]"
                        onClick={() => onArastir()}
                        disabled={arastirBusy}
                    >
                        {arastirBusy ? (
                            <Loader2 className="h-3.5 w-3.5 animate-spin mr-1" />
                        ) : (
                            <Sparkles className="h-3.5 w-3.5 mr-1" />
                        )}
                        Derin Araştır
                    </Button>
                </div>
            </RayicAccordion>

            <RayicAccordion title="Gelişmiş filtreler" defaultOpen={false}>
                <div className="space-y-2">
                    <button
                        type="button"
                        onClick={() => setShowGelismis((v) => !v)}
                        className="inline-flex items-center gap-1 text-[10px] text-slate-400"
                    >
                        <Filter className="h-3 w-3" />
                        {showGelismis ? "Gizle" : "Göster"}
                    </button>
                    <label className="flex items-center gap-1.5 text-[10px] text-slate-400">
                        <input
                            type="checkbox"
                            checked={gelismis.derin}
                            onChange={(e) => setGelismis((g) => ({ ...g, derin: e.target.checked }))}
                        />
                        Çok sayfa + web
                    </label>
                    <label className="flex items-center gap-1.5 text-[10px] text-slate-400">
                        <input
                            type="checkbox"
                            checked={gelismis.mutadil}
                            onChange={(e) => setGelismis((g) => ({ ...g, mutadil: e.target.checked }))}
                        />
                        Muadil model
                    </label>
                    {showGelismis ? (
                        <>
                            <Input
                                type="number"
                                value={gelismis.yil_tol}
                                onChange={(e) =>
                                    setGelismis((g) => ({ ...g, yil_tol: Number(e.target.value) || 1 }))
                                }
                                className="h-8 bg-black/20 border-white/10 text-xs"
                                placeholder="Yıl ±"
                            />
                            <Input
                                type="number"
                                step={0.05}
                                value={gelismis.km_oran}
                                onChange={(e) =>
                                    setGelismis((g) => ({ ...g, km_oran: Number(e.target.value) || 0.35 }))
                                }
                                className="h-8 bg-black/20 border-white/10 text-xs"
                                placeholder="KM oran"
                            />
                            <Input
                                type="number"
                                value={form.hasar_faturasi}
                                onChange={(e) => setForm((f) => ({ ...f, hasar_faturasi: e.target.value }))}
                                className="h-8 bg-black/20 border-white/10 text-xs"
                                placeholder="Hasar ₺"
                            />
                        </>
                    ) : null}
                </div>
            </RayicAccordion>
        </div>
    );
}
